import { render, staticRenderFns } from "./AwsFilesInfo.vue?vue&type=template&id=37ed0f34&scoped=true"
import script from "./AwsFilesInfo.vue?vue&type=script&lang=ts"
export * from "./AwsFilesInfo.vue?vue&type=script&lang=ts"
import style0 from "./AwsFilesInfo.vue?vue&type=style&index=0&id=37ed0f34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed0f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ed0f34')) {
      api.createRecord('37ed0f34', component.options)
    } else {
      api.reload('37ed0f34', component.options)
    }
    module.hot.accept("./AwsFilesInfo.vue?vue&type=template&id=37ed0f34&scoped=true", function () {
      api.rerender('37ed0f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/AwsFilesInfo.vue"
export default component.exports